"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var sales_force_auto_complete_1 = __importDefault(require("../../utils/sales_force/sales_force_auto_complete"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var OpportunityAdditionalTabletPre = /** @class */ (function (_super) {
    __extends(OpportunityAdditionalTabletPre, _super);
    function OpportunityAdditionalTabletPre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            additionalTabletPrice: '',
            additionalTabletContractState: '',
            additionalTabletRequestStartDate: null,
            additionalTabletContractEdate: null,
            additionalTabletItPeriod: '',
            additionalTabletItFlg: '',
            additionalTabletTokubetuFlg: '',
            additionalTabletTokubetuDetail: '',
            opportunityAdditionalTabletId: '',
            opportunityAdditionalTabletName: '',
            additionalTabletContractStartDate: null,
            additionalTabletPriceBook2Id: '',
            additionalTabletProductId: '',
            additionalTabletProductInitialFeeId: '',
            opportunityAdditionalTabletItemId: '',
            additionalTabletPriceBook2Name: '',
            additionalTabletPriceBook2Description: '',
            additionalTabletProductName: '',
            additionalTabletPriceDefault: '',
            additionalTabletPriceBookData: [],
            additionalTabletProductPlanName: '',
            additionalTabletPriceBookUrl: '',
            additionalTabletPriceBookMonth: '',
            additionalTabletPriceBookBillWay: '',
            applyInfoApplyCapacityAdditionalTablet: '',
            applyInfoAdditionalTabletStartDate: '',
            additionalTablets: '',
            displayDataTableObj: [],
            opportunityLeadSource: '',
            opportunityLtParentLs: '',
            opportunityLtSdate: '',
            opportunityGc: '',
            opportunityFtChildLs: '',
            opportunityLtChildLs: ''
        };
        _this.additionalTabletPrice = '';
        _this.additionalTabletItFlgDisabled = false;
        _this.additionalTabletItFlgDescription = false;
        _this.loading = false;
        // DataTable表示用
        _this.displayDataTableObj = {
            tabletsTotalPrice: 0,
            initialFeeTotalPrice: 0,
            rehabCloudTabletInitialFeeText: '',
            rehabCloudTabletText: '',
            rehabCloudTabletMonthly: '',
            rehabCloudTabletInitialFeeMonthly: ''
        };
        _this.alertDialogMessage = '';
        // 表示専用 DBと連携しない
        _this.fixedTextItem = '';
        // 価格表[Rehab Cloud]が選択されているかを判別する。
        _this.watchingPriceBook2Id = '';
        // [Rehab Cloud]のみの価格表
        _this.rehabCloudPriceBook = [];
        return _this;
    }
    OpportunityAdditionalTabletPre.prototype.data = function () {
        return {
            tabletHeaders: [
                {
                    text: '商品名',
                    value: 'productName'
                },
                {
                    text: '単価',
                    value: 'unitPrice'
                },
                { text: '台数',
                    value: 'tabletNumbers'
                },
                { text: '合計',
                    value: 'total'
                }
            ],
            tabletItems: [
                {
                    productName: '',
                    unitPrice: 0,
                    tabletNumbers: 0,
                    total: 0
                }
            ]
        };
    };
    OpportunityAdditionalTabletPre.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityAdditionalTabletPre.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityAdditionalTabletPre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityAdditionalTabletPre.prototype.startLoading = function () {
        this.loading = true;
    };
    OpportunityAdditionalTabletPre.prototype.endLoading = function () {
        this.loading = false;
    };
    OpportunityAdditionalTabletPre.prototype.priceBook2IdChanged = function () {
        if (value_checker_1.default.isPresent(this.salesForceInfo.additionalTabletPriceBook2Id)) {
            this.defaultPriceBookData();
        }
    };
    OpportunityAdditionalTabletPre.prototype.registeredOrNot = function () {
        // タブレットの台数、Object、利用開始月、特別対応の詳細が登録されていること
        if (this.salesForceInfo.displayDataTableObj &&
            value_checker_1.default.isPresent(this.salesForceInfo.additionalTablets) &&
            !this.isTokubetuBlank() &&
            !this.isStartDateBlank()) {
            return true;
        }
        return false;
    };
    OpportunityAdditionalTabletPre.prototype.defaultPriceBookData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, response, productItems, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletPriceBook2Id)) {
                            this.alertMessage = "タブレット単体申込でERRORが発生しています。開発にご連絡下さい";
                            this.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        // すでに登録がなされている場合、ここでreturnする。
                        if (this.registeredOrNot()) {
                            // DataTable表示用として再代入
                            this.displayDataTableObj = this.salesForceInfo.displayDataTableObj;
                            // 固定テキストSET
                            this.fixedTextItem = 'Rehab Cloud タブレット + Rehab Cloud タブレット初回手数料';
                            return [2 /*return*/];
                        }
                        self_ = this;
                        self_.startLoading();
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create("sales_force/get_pricebook_entry/" + self_.salesForceInfo.additionalTabletPriceBook2Id);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axios_1.default.get(url_, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 3:
                        response = _a.sent();
                        productItems = null;
                        if (response.data['priceBookEntryList']) {
                            productItems = response.data['priceBookEntryList'];
                            productItems.unshift({
                                value: ' ',
                                text: String(self_.$t('dictionary.select.default_text')),
                                price: ' '
                            });
                        }
                        // 商品ファミリー「Rehab Cloud Tablet」の名称と単価を取得
                        self_.defaultPriceBookTablet = productItems.filter(function (item) {
                            if (item.family === "Rehab Cloud タブレット") {
                                self_.displayDataTableObj["rehabCloudTabletText"] = item.text;
                                self_.displayDataTableObj["rehabCloudTabletMonthly"] = parseInt(item.price);
                                self_.salesForceInfo.additionalTabletProductId = item.value;
                            }
                            return item.family === "Rehab Cloud タブレット";
                        });
                        // 商品ファミリー「Rehab Cloud Tablet」の名称と単価を取得
                        self_.defaultPriceBookTabletInitialFee = productItems.filter(function (item) {
                            if (item.family === "Rehab Cloud タブレット初回手数料") {
                                self_.displayDataTableObj["rehabCloudTabletInitialFeeText"] = item.text;
                                self_.displayDataTableObj["rehabCloudTabletInitialFeeMonthly"] = parseInt(item.price);
                                self_.salesForceInfo.additionalTabletProductInitialFeeId = item.value;
                            }
                            return item.family === "Rehab Cloud タブレット初回手数料";
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        self_.endLoading();
                        self_.alertDialogMessage = 'タブレット単体申込み対応でERRORが発生しています。開発にご連絡下さい';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 5:
                        // 固定テキストSET
                        this.fixedTextItem = 'Rehab Cloud タブレット + Rehab Cloud タブレット初回手数料';
                        self_.endLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityAdditionalTabletPre.prototype.additionalTabletsChange = function () {
        // タブレットの価格 = 単価✕入力数
        this.displayDataTableObj["tabletsTotalPrice"] = parseInt(this.displayDataTableObj["rehabCloudTabletMonthly"]) * this.salesForceInfo.additionalTablets;
        // タブレット初回手数料 = 単価✕入力数
        this.displayDataTableObj["initialFeeTotalPrice"] = parseInt(this.displayDataTableObj["rehabCloudTabletInitialFeeMonthly"]) * this.salesForceInfo.additionalTablets;
        // this.displayDataTableObj["initialFeeTotalPrice"] += "（初月のみ）";
    };
    OpportunityAdditionalTabletPre.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletRequestStartDate)) {
            this.salesForceInfo.additionalTabletRequestStartDate = sales_force_auto_complete_1.default.getRequestStartDate(this.salesForceInfo.additionalTabletContractStartDate);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletContractEdate)) {
            this.salesForceInfo.additionalTabletContractEdate = sales_force_auto_complete_1.default.getContractEdate(this.salesForceInfo.additionalTabletContractStartDate, this.form.applyInfoAdditionalTabletPeriod);
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityAdditionalTabletName)) {
            this.salesForceInfo.opportunityAdditionalTabletName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
    };
    OpportunityAdditionalTabletPre.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityAdditionalTabletPre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityAdditionalTabletPre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.additionalTabletPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                // 利用開始月が未入力の場合、登録することは出来ない。
                if (this.isStartDateBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.arert_start_date').toString();
                    return [2 /*return*/];
                }
                // タブレット台数が未入力の場合、登録することは出来ない。
                // タブレット台数がundefinedの場合もValueChecker.isBlankにて判定する。
                if (value_checker_1.default.isBlank(self_.salesForceInfo.additionalTablets)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_empty_tablet_number').toString();
                    return [2 /*return*/];
                }
                // タブレット台数が0またはマイナスの数値の場合、登録することは出来ない。
                if (self_.salesForceInfo.additionalTablets <= 0) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_invalid_tablet_number').toString();
                    return [2 /*return*/];
                }
                // Rehab Cloud タブレット初回手数料／Rehab Cloud タブレットが0またはマイナスの数値の場合、登録することは出来ない。
                // また、初期化に失敗し、undefined／空白文字列／nullの場合もValueChecker.isBlankにて判定する。
                if (value_checker_1.default.isBlank(String(self_.displayDataTableObj.initialFeeTotalPrice)) || self_.displayDataTableObj.initialFeeTotalPrice <= 0 ||
                    value_checker_1.default.isBlank(String(self_.displayDataTableObj.tabletsTotalPrice)) || self_.displayDataTableObj.tabletsTotalPrice <= 0) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_invalid_tablet_calculation').toString();
                    return [2 /*return*/];
                }
                // 特別対応が未入力の場合、登録することは出来ない。
                if (this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.tokubetu_error_second').toString();
                    return [2 /*return*/];
                }
                this.confirmMessage = "<strong>\u30BF\u30D6\u30EC\u30C3\u30C8\u3092" + self_.salesForceInfo.additionalTablets + "\u53F0\u767B\u9332\u3057\u307E\u3059\u3002</strong>\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F";
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityAdditionalTabletPre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityAdditionalTabletPre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityAdditionalTabletPre.prototype.getPriceErrorMsg = function () {
        if (this.isPriceDifferent()) {
            return this.$t('view.sales_force.reflect.msg.price_warning');
        }
        return '';
    };
    OpportunityAdditionalTabletPre.prototype.isPriceDifferent = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletPrice)) {
            return false;
        }
        return String(this.additionalTabletPrice) !== String(this.salesForceInfo.additionalTabletPrice);
    };
    OpportunityAdditionalTabletPre.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletTokubetuDetail);
    };
    OpportunityAdditionalTabletPre.prototype.isStartDateBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.applyInfoAdditionalTabletStartDate);
    };
    OpportunityAdditionalTabletPre.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityAdditionalTabletId) {
            this.salesForceInfo.opportunityAdditionalTabletId = '';
        }
        if (!this.salesForceInfo.opportunityAdditionalTabletItemId) {
            this.salesForceInfo.opportunityAdditionalTabletItemId = '';
        }
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                additionalTabletPrice: this.salesForceInfo.additionalTabletPrice,
                additionalTabletContractState: this.salesForceInfo.additionalTabletContractState,
                additionalTabletRequestStartDate: this.salesForceInfo.additionalTabletRequestStartDate,
                additionalTabletContractEdate: this.salesForceInfo.additionalTabletContractEdate,
                additionalTabletItPeriod: this.salesForceInfo.additionalTabletItPeriod,
                additionalTabletItFlg: this.salesForceInfo.additionalTabletItFlg,
                additionalTabletTokubetuFlg: this.salesForceInfo.additionalTabletTokubetuFlg,
                additionalTabletTokubetuDetail: this.salesForceInfo.additionalTabletTokubetuDetail,
                opportunityAdditionalTabletId: this.salesForceInfo.opportunityAdditionalTabletId.trim(),
                opportunityAdditionalTabletName: this.salesForceInfo.opportunityAdditionalTabletName,
                additionalTabletContractStartDate: this.salesForceInfo.additionalTabletContractStartDate,
                // 自動でSETされる。
                additionalTabletPriceBook2Id: this.salesForceInfo.additionalTabletPriceBook2Id,
                opportunityAdditionalTabletItemId: this.salesForceInfo.opportunityAdditionalTabletItemId.trim(),
                additionalTabletPriceBook2Description: this.salesForceInfo.additionalTabletPriceBook2Description,
                additionalTabletPriceBook2Name: this.salesForceInfo.additionalTabletPriceBook2Name,
                additionalTabletProductName: this.salesForceInfo.additionalTabletProductName,
                additionalTabletPriceDefault: this.salesForceInfo.additionalTabletPriceDefault,
                additionalTabletPriceBookData: this.salesForceInfo.additionalTabletPriceBookData,
                additionalTabletProductPlanName: this.salesForceInfo.additionalTabletProductPlanName,
                additionalTabletPriceBookUrl: this.salesForceInfo.additionalTabletPriceBookUrl,
                additionalTabletPriceBookMonth: this.salesForceInfo.additionalTabletPriceBookMonth,
                additionalTabletPriceBookBillWay: this.salesForceInfo.additionalTabletPriceBookBillWay,
                applyInfoAdditionalTabletStartDate: this.salesForceInfo.applyInfoAdditionalTabletStartDate,
                additionalTablets: this.salesForceInfo.additionalTablets,
                displayDataTableObj: this.displayDataTableObj,
                opportunityLeadSource: this.salesForceInfo.opportunityLeadSource,
                opportunityLtParentLs: this.salesForceInfo.opportunityLtParentLs,
                opportunityLtSdate: this.salesForceInfo.opportunityLtSdate,
                opportunityGc: this.salesForceInfo.opportunityGc,
                opportunityFtChildLs: this.salesForceInfo.opportunityFtChildLs,
                opportunityLtChildLs: this.salesForceInfo.opportunityLtChildLs
            },
            reflectType: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityAdditionalTabletPre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityAdditionalTabletPre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityAdditionalTabletPre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityAdditionalTabletPre.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], OpportunityAdditionalTabletPre.prototype, "isLinkComplete", void 0);
    __decorate([
        vue_property_decorator_1.Watch('salesForceInfo.additionalTabletPriceBook2Id')
    ], OpportunityAdditionalTabletPre.prototype, "priceBook2IdChanged", null);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityAdditionalTabletPre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityAdditionalTabletPre.prototype, "initSalesForceDataChange", null);
    OpportunityAdditionalTabletPre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                Loading: Loading_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityAdditionalTabletPre);
    return OpportunityAdditionalTabletPre;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityAdditionalTabletPre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityAdditionalTabletPre.vue
// module id = THeo
// module chunks = 1